import {
  FetchProductsByCategory,
  FetchCategories,
  FetchCategoryCategories,
  DeleteProduct,
  DeleteCategory,
} from "@greeter/venue-api";
import { useActor } from "@xstate/react";
import {
  PickedProduct,
  ProductLibraryApiRequirements,
  productLibraryMachine,
  providApiForActor,
} from "./ProductLibraryMachine";
import { fromPromise } from "xstate";
import { IonContent, IonIcon, IonModal, useIonAlert } from "@ionic/react";
import { PropsWithChildren, useEffect } from "react";

import { Product } from "@greeter/core";
import { ProductEditor } from "../ProductEditor";
import {
  CategoryEditor,
  CategoryEditorApiRequirements,
} from "../CategoryEditor/CategoryEditor";
import {
  FloatingBackButton,
  NonBlockingSpinner,
  Toolbar,
} from "@greeter/matter";
import { classNames } from "@greeter/util";
import { addCircleOutline, createOutline, trashOutline } from "ionicons/icons";

import css from "./ProductLibrary.module.scss";
import { FloatingButton } from "../FloatingButton/FloatingButton";

export type ProductLibraryProps = {
  // The selection after all have products have been selected.
  onSelected?: (productIds: Array<string>) => void;
  onPick?: (args: {
    productId: string;
    productName: string;
    categoryId: string;
    categoryName: string;
  }) => void;
  onExit?: (args: { selectedProducts: Array<PickedProduct> }) => void;
  onSaved?: () => Promise<void> | void;
  api: ProductLibraryApiRequirements;
};

type ItemToolbarProps = {
  onEdit: () => void;
  onDelete: () => void;
};
function ItemToolbar(props: ItemToolbarProps) {
  return (
    <div className={css.ItemToolbar}>
      <IonIcon
        style={{ height: 20, width: 20 }}
        onClick={(ev) => {
          ev.stopPropagation();
          props.onDelete();
        }}
        icon={trashOutline}
      />
      <IonIcon
        style={{ width: 20, height: 20 }}
        onClick={(ev) => {
          ev.stopPropagation();
          props.onEdit();
        }}
        icon={createOutline}
      />
    </div>
  );
}

type ItemProps = PropsWithChildren & {
  onClick?: () => void;
  className?: string;
};
function Item(props: ItemProps) {
  return <div {...props} {...classNames(css.Item, props.className)} />;
}

type AddItemProps = PropsWithChildren & {
  onClick?: () => void;
};
function AddItem(props: AddItemProps) {
  return <div className={`${css.Item} ${css.AddItem}`} {...props} />;
}

export function ProductLibrary(props: ProductLibraryProps) {
  const [snap, send, m] = useActor(
    providApiForActor(productLibraryMachine, props.api)
  );

  useEffect(() => {
    function onBack(ev: PopStateEvent) {
      if (snap.matches({ ui: "browsingCategories" })) {
        ev.preventDefault();
        send({ type: "back" });
      }
    }
    window.addEventListener("popstate", onBack);
    return () => window.removeEventListener("popstate", onBack);
  }, []);

  // useEffect(() => m.on("categories.saved", () => {
  //   send({ type: "})
  // }).unsubscribe, [m]);

  const [alert] = useIonAlert();

  return (
    <div className={css.ProductLibrary}>
      <FloatingBackButton
        onClick={(fallback) => {
          if (snap.value.ui !== "browsingCategories") {
            send({ type: "back" });
          } else if (props.onExit) {
            props.onExit({
              selectedProducts: Array.from(
                snap.context.selectedProducts.values()
              ),
            });
          } else {
            fallback();
          }
        }}
      />
      {/*snap.context.selectedProducts.size > 0 && (
        <Toolbar
          rightSlot={
            <div className={css.ActionBar}>
              <div
                style={{ height: "100%" }}
                onClick={() => {
                  send({ type: "done" });
                  if (props.onExit) {
                    props.onExit({
                      selectedProducts: Array.from(
                        snap.context.selectedProducts.values()
                      ),
                    });
                  }
                }}
              >
                Vælg {snap.context.selectedProducts.size}
              </div>
            </div>
          }
        />
      )*/}
      <h1 style={{ fontWeight: "bold", fontSize: "1.5rem", padding: "2rem" }}>
        {snap.value.ui === "browsingCategories" ||
        snap.value.ui === "editingCategory"
          ? "Vælg kategori"
          : snap.value.ui === "browsingProductsInCategory" ||
            snap.value.ui === "editingProduct"
          ? "Vælg produkt"
          : ""}
      </h1>
      <div className={css.Content}>
        {(snap.value.ui === "browsingProductsInCategory" ||
          snap.value.ui === "editingProduct") && (
          <p>
            {
              snap.context.categories.find(
                (c) => c.id === snap.context.browsingCategoryId
              )?.name
            }
          </p>
        )}

        {(snap.value.ui === "browsingCategories" ||
          snap.value.ui === "editingCategory") &&
          snap.context.categoryCategories.map((cc) => {
            return (
              <div>
                <h2 style={{ textAlign: "left" }}>{cc.name}</h2>
                <div className={css.ItemGrid}>
                  {snap.context.categoriesByCategoryCategory
                    .get(cc.id)
                    ?.map((c) => {
                      console.debug("CATEGORY", c);
                      return (
                        <Item
                          key={c.id}
                          onClick={() => {
                            send({ type: "browseCategory", categoryId: c.id });
                            send({ type: "fetchProductsByCategory" });
                          }}
                        >
                          <ItemToolbar
                            onEdit={() => {
                              send({
                                type: "editCategory",
                                data: {
                                  categoryId: c.id,
                                  categoryCategoryId: cc.id,
                                },
                              });
                            }}
                            onDelete={() => {
                              alert({
                                header: "Er du sikker?",
                                message:
                                  "Dette vil slette kategorien men ikke de underliggende produkter. De vil bare miste deres kategori.",
                                buttons: [
                                  {
                                    text: "Ja",
                                    handler() {
                                      send({
                                        type: "deleteCategory",
                                        data: c.id,
                                      });
                                    },
                                  },
                                  { text: "Nej" },
                                ],
                              });
                            }}
                          />
                          {c.name}
                        </Item>
                      );
                    })}
                  <AddItem
                    onClick={() => {
                      send({ type: "setLastCategoryCategoryId", data: cc.id });
                      send({
                        type: "editCategory",
                        data: { categoryCategoryId: cc.id },
                      });
                    }}
                  >
                    + Tilføj kategori
                  </AddItem>
                </div>
              </div>
            );
          })}

        {(snap.value.ui === "browsingProductsInCategory" ||
          snap.value.ui === "editingProduct") && (
          <div className={css.ItemGrid}>
            {(
              snap.context.productsByCategory.get(
                snap.context.browsingCategoryId ?? ""
              ) ?? []
            ).map((p: Product) => {
              return (
                <Item
                  key={p.id}
                  {...classNames(
                    snap.context.selectedProducts.has(p.id) && css.SelectedItem
                  )}
                  onClick={() => {
                    send({ type: "selectProduct", productId: p.id });
                    if (props.onPick)
                      props.onPick({
                        productId: p.id,
                        productName: p.title,
                        categoryId: snap.context.browsingCategoryId ?? "",
                        categoryName:
                          snap.context.categories.find(
                            (c) => c.id === snap.context.browsingCategoryId
                          )?.name ?? "",
                      });
                  }}
                >
                  <ItemToolbar
                    onEdit={() => {
                      send({ type: "editProduct", productId: p.id });
                    }}
                    onDelete={() => {
                      alert("Er du sikker på at du vil slette produktet?", [
                        {
                          text: "Ja",
                          handler() {
                            send({ type: "deleteProduct", productId: p.id });
                          },
                        },
                        { text: "Nej" },
                      ]);
                    }}
                  />
                  {p.title}
                </Item>
              );
            })}
            <AddItem onClick={() => send({ type: "editProduct" })}>
              + Tilføj produkt
            </AddItem>
          </div>
        )}
      </div>

      <FloatingButton
        show={Array.from(snap.context.selectedProducts.values()).length > 0}
        onClick={() => {
          send({ type: "done" });
          if (props.onExit) {
            props.onExit({
              selectedProducts: Array.from(
                snap.context.selectedProducts.values()
              ),
            });
          }
        }}
      >
        <IonIcon style={{ width: 40, height: 40 }} icon={addCircleOutline} />
        Vælg {snap.context.selectedProducts.size}
      </FloatingButton>

      <IonModal
        mode="ios"
        isOpen={snap.value.ui === "editingProduct"}
        onDidDismiss={() => {
          if (snap.value.ui === "editingProduct") {
            send({ type: "back" });
          }
        }}
      >
        <IonContent>
          <ProductEditor
            api={props.api}
            categoryId={snap.context.browsingCategoryId}
            productId={snap.context.editingProductId}
            onExit={() => send({ type: "back" })}
            onSaved={async () => {
              console.log(`[${ProductLibrary.name}] onSaved triggered`);
              send({ type: "fetchProductsByCategory" });
              send({ type: "back" });
            }}
          />
        </IonContent>
      </IonModal>

      <IonModal
        isOpen={snap.value.ui === "editingCategory"}
        mode="ios"
        onDidDismiss={() => {
          if (snap.value.ui === "editingCategory") {
            send({ type: "back" });
          }
        }}
      >
        <IonContent>
          <CategoryEditor
            api={props.api}
            categoryId={snap.context.editingCategoryId}
            categoryCategoryId={snap.context.lastCategoryCategoryId}
            onExit={() => send({ type: "back" })}
            onSaved={() => {
              send({ type: "fetchCategories" });
              send({ type: "back" });
            }}
          />
        </IonContent>
      </IonModal>

      <NonBlockingSpinner
        reason={
          snap.matches({
            api: { category: "deleting" },
            ui: "browsingCategories",
          })
            ? "Sletter kategori"
            : snap.matches({
                api: { categories: "fetching" },
                ui: "browsingCategories",
              })
            ? "Henter kategorier"
            : snap.matches({
                api: { product: "deleting" },
                ui: "browsingProductsInCategory",
              })
            ? "Sletter produkt"
            : snap.matches({
                api: { products: "fetching" },
                ui: "browsingProductsInCategory",
              }) && "Henter produkter"
        }
      />
    </div>
  );
}
